export enum ZollApiConstants {
  THROW_API_EXCEPTION = 'zollapi/throwApiException',
}
